export const NAT_TYPE_MAP = {
  '0': '其它',
  '1': '公网型',
  '2': '全锥型',
  '3': 'IP限制型',
  '4': '端口限制型',
  '5': '对称型',
  '5.1': '对称型',
  '6': '映射公网型',
};

export const DISPATCH_RANGE = 'dispatch_range'

export const DISPATCH_RANGE_OPTIONS = [
  {
    value: 'provincial',
    label: '可同省调度',
  },
  {
    value: 'peak',
    label: '可限制时段',
  }
]

export const DEVICE_WKYC_TYPE = '1';
export const DEVICE_XA_TYPE = '2';
export const DEVICE_X86_TYPE = '3';
export const DEVICE_SF_TYPE = '4';
export const DEVICE_ZQB3PRO_TYPE = '5';
export const DEVICE_PC_TYPE = '6';
export const DEVICE_CONTAIN_TYPE = '7';
export const PRODUCT_TYPE_MAP = {
  [DEVICE_WKYC_TYPE]: '玩客云现金版',
  [DEVICE_XA_TYPE]: '小爱盒子',
  [DEVICE_X86_TYPE]: 'x86',
  [DEVICE_SF_TYPE]: '三方盒子',
  [DEVICE_ZQB3PRO_TYPE]: '玩客云-赚钱宝3代pro',
  [DEVICE_PC_TYPE]: '赚钱宝电脑版',
  [DEVICE_CONTAIN_TYPE]: '容器魔方',
  // "WxBox" :    "网心盒子",
  // "WxOpen":    "网心云开放版",
  // "ZQBPC" :     "赚钱宝电脑版",
};

export const DEVICE_OPTIONS = [
  {
    label: PRODUCT_TYPE_MAP[DEVICE_WKYC_TYPE],
    value: DEVICE_WKYC_TYPE,
  },
  {
    label: PRODUCT_TYPE_MAP[DEVICE_X86_TYPE],
    value: DEVICE_X86_TYPE,
  },
  {
    label: PRODUCT_TYPE_MAP[DEVICE_SF_TYPE],
    value: DEVICE_SF_TYPE,
  },
  {
    label: PRODUCT_TYPE_MAP[DEVICE_ZQB3PRO_TYPE],
    value: DEVICE_ZQB3PRO_TYPE,
  },
  {
    label: PRODUCT_TYPE_MAP[DEVICE_PC_TYPE],
    value: DEVICE_PC_TYPE,
  },
];

export const DEVICE_TYPE_MAP = {
  '-1': '未知',
  '1': '玩客云',
  '2': '三方盒子',
  '3': '我家云',
  '4': '玩客云pro',
  '5': 'x8',
};
export const BUTTON_INFO_MAP = {
  recruiting: {
    btnText: '申请加入',
    btnClass: '',
  },
  finish: {
    btnText: '即将开启，敬请期待',
    btnClass: 'disable',
  },
};
export const PAGE_SIZE = 20;

export const FILTER_TABS = [
  {
    label: '省份',
    value: 'province',
  },
  {
    label: '运营商',
    value: 'operator',
  },
  {
    label: 'NAT类型',
    value: 'natType',
  },
  {
    label: '昨日收益',
    value: 'income',
  },
];

export const DEVICE_TYPE = 'device_type';
export const PROVINCE_TYPE = 'province';
export const ISP_TYPE = 'isp';
export const MORE_TYPE = 'more';
export const RECRUIT_FILTER_OPTIONS = [
  {
    label: '设备类型',
    value: DEVICE_TYPE,
  },
  {
    label: '省份',
    value: PROVINCE_TYPE,
  },
  {
    label: '运营商',
    value: ISP_TYPE,
  },
  {
    label: '更多',
    value: MORE_TYPE,
  },
];

export const RESULT_FILTER_TABS = [
  {
    label: '定向业务',
    value: 'bizId',
  },
  {
    label: '审核状态',
    value: 'status',
  },
  {
    label: '排序',
    value: 'sort',
  },
];

export const RESULT_ORDER_OPTIONS = [
  {
    id: 0,
    label: '默认排序',
  },
  {
    id: 1,
    label: '按审核时间降序排列',
  },
  {
    id: 2,
    label: '按审核时间升序排列',
  },
];

export const DEFAULT_RESULT_FILTER = {
  bizId: '0',
  status: 0,
  sort: 0,
};

export const CHECKING_STATUS = 1;
export const FAIL_STATUS = 2;
export const SUCCESS_STATUS = 3;
export const QUIT_STATUS = 4;

// export const STATUS_INFO_MAP = {
//   [CHECKING_STATUS]: { statusText: '审核中', timeText: '审核时间' },
//   [FAIL_STATUS]: { statusText: '审核失败', timeText: '审核时间' },
//   // [FAIL_STATUS]: { statusText: '已报备下线', timeText: '审核时间' },
//   [SUCCESS_STATUS]: { statusText: '审核通过', timeText: '审核时间' },
//   // [SUCCESS_STATUS]: { statusText: '等待业务方审核', timeText: '审核时间' },
//   [QUIT_STATUS]: { statusText: '已退出', timeText: '退出时间' },
// };

export const STATUS_INFO_MAP = {
  1: { statusText: '审核中', timeText: '审核时间' },
  2: { statusText: '审核不通过', timeText: '审核时间' },
  // [FAIL_STATUS]: { statusText: '已报备下线', timeText: '审核时间' },
  3: { statusText: '审核通过', timeText: '审核时间' },
  // [SUCCESS_STATUS]: { statusText: '等待业务方审核', timeText: '审核时间' },
  4: { statusText: '已退出', timeText: '退出时间' },
  5: { statusText: '预清退', timeText: '审核时间' },
  6: { statusText: '报备下线', timeText: '审核时间' },
  7: { statusText: '二次验收', timeText: '审核时间' },
  8: { statusText: '设备重装', timeText: '审核时间' },
  9: { statusText: '重新验收中', timeText: '审核时间' },
};

export const RESULT_STATUS_OPTIONS = [
  {
    id: 0,
    label: '全部',
  },
  {
    id: CHECKING_STATUS,
    label: '审核中',
  },
  {
    id: FAIL_STATUS,
    label: '审核失败',
  },
  {
    id: SUCCESS_STATUS,
    label: '正在运行',
  },
  {
    id: QUIT_STATUS,
    label: '已退出',
  },
  {
    id: 5,
    label: '预清退',
  },
  {
    id: 6,
    label: '报备下线',
  },
  {
    id: 7,
    label: '审核中',
  },
  {
    id: 8,
    label: '请重新验收',
  },
  {
    id: 9,
    label: '重新验收中',
  },
];

export const RESULT_STATUS_OPTIONS_FILTER = [
  {
    id: 0,
    label: '全部',
  },
  {
    id: CHECKING_STATUS,
    label: '审核中',
  },
  {
    id: FAIL_STATUS,
    label: '审核失败',
  },
  {
    id: SUCCESS_STATUS,
    label: '正在运行',
  },
  {
    id: QUIT_STATUS,
    label: '已退出',
  },
  {
    id: 5,
    label: '预清退',
  },
  {
    id: 6,
    label: '报备下线',
  },
  {
    id: 8,
    label: '请重新验收',
  },
  {
    id: 9,
    label: '重新验收中',
  },
];

export const DEFAULT_APPLY_FILTER = {
  operator: [],
  province: [],
  natType: [],
  income: [],
};

export const TEMPLATE_A = 0;
export const TEMPLATE_B = 1;

export const PROVINCE_OPTIONS = [
  {
    type: 'A',
    sub_list: [
      // {
      //   value: '34',
      //   label: '澳门',
      // },
      {
        value: '9',
        label: '安徽省',
      },
    ],
  },
  {
    type: 'B',
    sub_list: [
      {
        value: '1',
        label: '北京市',
      },
    ],
  },
  {
    type: 'C',
    sub_list: [
      {
        value: '4',
        label: '重庆市',
      },
    ],
  },
  {
    type: 'F',
    sub_list: [
      {
        value: '22',
        label: '福建省',
      },
    ],
  },
  {
    type: 'G',
    sub_list: [
      {
        value: '21',
        label: '甘肃省',
      },
      {
        value: '12',
        label: '广东省',
      },
      {
        value: '29',
        label: '广西',
      },
      {
        value: '23',
        label: '贵州省',
      },
    ],
  },
  {
    type: 'H',
    sub_list: [
      {
        value: '16',
        label: '河南省',
      },
      {
        value: '18',
        label: '海南省',
      },
      {
        value: '15',
        label: '河北省',
      },
      {
        value: '19',
        label: '湖北省',
      },
      {
        value: '27',
        label: '黑龙江省',
      },
      {
        value: '20',
        label: '湖南省',
      },
    ],
  },
  {
    type: 'J',
    sub_list: [
      {
        value: '14',
        label: '江西省',
      },
      {
        value: '7',
        label: '吉林省',
      },
      {
        value: '13',
        label: '江苏省',
      },
    ],
  },
  {
    type: 'L',
    sub_list: [
      {
        value: '24',
        label: '辽宁省',
      },
    ],
  },
  {
    type: 'N',
    sub_list: [
      {
        value: '31',
        label: '宁夏',
      },
      {
        value: '32',
        label: '内蒙古',
      },
    ],
  },
  {
    type: 'Q',
    sub_list: [
      {
        value: '26',
        label: '青海省',
      },
    ],
  },
  {
    type: 'S',
    sub_list: [
      {
        value: '10',
        label: '山东省',
      },
      {
        value: '11',
        label: '山西省',
      },
      {
        value: '8',
        label: '四川省',
      },
      {
        value: '2',
        label: '上海市',
      },
      {
        value: '25',
        label: '陕西省',
      },
    ],
  },
  {
    type: 'T',
    sub_list: [
      // {
      //   value: '6',
      //   label: '台湾省',
      // },
      {
        value: '3',
        label: '天津市',
      },
    ],
  },
  {
    type: 'X',
    sub_list: [
      {
        value: '30',
        label: '新疆',
      },
      {
        value: '28',
        label: '西藏',
      },
      // {
      //   value: '33',
      //   label: '香港',
      // },
    ],
  },
  {
    type: 'Y',
    sub_list: [
      {
        value: '5',
        label: '云南省',
      },
    ],
  },
  {
    type: 'Z',
    sub_list: [
      {
        value: '17',
        label: '浙江省',
      },
    ],
  },
];

export const ISP_OPTIONS = [
  {
    value: '1',
    label: '电信',
  },
  {
    value: '2',
    label: '联通',
  },
  {
    value: '5',
    label: '移动',
  },
];

export const NAT_TYPE = 'nat_type';
export const SINGLE_UPLOAD_TYPE = 'single_upload';
export const SINGLE_CONVERGE_TYPE = 'converge_upload';
export const DIAL_TYPE = 'dial_type';
export const DISK_CAPACITY_TYPE = 'disk_capacity';
export const MEM_CAPACITY_TYPE = 'memory';
export const CPU_TYPE = 'cpu_threads';
export const DISK_TYPE = 'disk_type';

export const NAT_OPTIONS = [
  {
    value: '1',
    label: '公网',
  },
  {
    value: '2',
    label: '全锥',
  },
];

export const DIAL_OPTIONS = [
  {
    value: '1',
    label: '服务器拨号',
  },
  {
    value: '2',
    label: '外置软路由拨号',
  },
  {
    value: '3',
    label: '静态IP',
  },
];

export const DISK_OPTIONS = [
  {
    value: '1',
    label: 'HDD',
  },
  {
    value: '2',
    label: 'SSD',
  },
  {
    value: '3',
    label: '混盘(HDD+SSD)',
  },
];

export const SINGLE_UPLOAD_INFO = {
  max: 500,
  min: 0,
  step: 20,
};

export const SINGLE_CONVERGE_INFO = {
  max: 2000,
  min: 50,
  step: 20,
};

export const DISK_CAPACITY_INFO = {
  max: 14,
  min: 0,
  step: 1,
};

export const CPU_INFO = {
  max: 64,
  min: 8,
  step: 2,
  // marks: {
  //   8: '8',
  //   12: '12',
  //   16: '16',
  //   24: '24',
  //   32: '32',
  //   48: '48',
  //   64: '64',
  // },
};

export const MEM_CAPACITY_INFO = {
  max: 128,
  min: 2,
  step: 2,
  // marks: {
  //   4: '4',
  //   8: '8',
  //   16: '16',
  //   24: '24',
  //   32: '32',
  //   48: '48',
  //   64: '64',
  //   128: '128',
  // },
};

// 列表标签
export const LIST_MODE = 'list';
// 滑块
export const SLIDER_MODE = 'slider';
// 输入框
export const INPUT_MODE = 'input';

export const MORE_FILTER_INFO = [
  {
    id: DISPATCH_RANGE,
    title: '业务特性',
    type: LIST_MODE,
    data: DISPATCH_RANGE_OPTIONS,
    unit: '',
  },
  {
    id: NAT_TYPE,
    title: 'NAT类型',
    type: LIST_MODE,
    data: NAT_OPTIONS,
    unit: '',
  },
  {
    id: SINGLE_UPLOAD_TYPE,
    title: '单条上行',
    type: INPUT_MODE,
    data: SINGLE_UPLOAD_INFO,
    unit: 'M',
  },
  {
    id: SINGLE_CONVERGE_TYPE,
    title: '单机上行',
    type: INPUT_MODE,
    data: SINGLE_CONVERGE_INFO,
    unit: 'G',
  },
  {
    id: DIAL_TYPE,
    title: '联网类型',
    type: LIST_MODE,
    data: DIAL_OPTIONS,
    unit: '',
  },
  {
    id: DISK_TYPE,
    title: '磁盘类型',
    type: LIST_MODE,
    data: DISK_OPTIONS,
    unit: '',
  },
  {
    id: DISK_CAPACITY_TYPE,
    title: '磁盘存储',
    type: INPUT_MODE,
    data: DISK_CAPACITY_INFO,
    unit: 'T',
  },
  {
    id: CPU_TYPE,
    title: 'CPU线程数',
    type: SLIDER_MODE,
    data: CPU_INFO,
    unit: '',
  },
  {
    id: MEM_CAPACITY_TYPE,
    title: '内存存储',
    type: SLIDER_MODE,
    data: MEM_CAPACITY_INFO,
    unit: 'G',
  },
];

export const DEFAULT_FILTER_OPTIONS = {
  [DEVICE_TYPE]: DEVICE_OPTIONS,
  [PROVINCE_TYPE]: PROVINCE_OPTIONS,
  [ISP_TYPE]: ISP_OPTIONS,
  [MORE_TYPE]: MORE_FILTER_INFO,
};

export const DEFAULT_MORE_FILTER = {
  [NAT_TYPE]: [],
  [SINGLE_UPLOAD_TYPE]: undefined,
  [SINGLE_CONVERGE_TYPE]: undefined,
  [DIAL_TYPE]: [],
  [DISK_CAPACITY_TYPE]: undefined,
  [MEM_CAPACITY_TYPE]: `${MEM_CAPACITY_INFO.max}`,
  [CPU_TYPE]: `${CPU_INFO.max}`,
  [DISK_TYPE]: [],
};

export const DEFAULT_FILTER_DATA = {
  [DEVICE_TYPE]: [],
  [PROVINCE_TYPE]: [],
  [ISP_TYPE]: [],
  [MORE_TYPE]: { ...DEFAULT_MORE_FILTER },
};
